import React, { useState } from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';

const ToggleLink = styled.button`
  background: none;
  border: none;
  color: ${p => p.theme.colors.text.muted};
  font-size: 13px;
  cursor: pointer;
  padding: ${p => p.theme.spacing[2]}px 0;
  text-decoration: underline;
  margin-top: ${p => p.theme.spacing[5]}px;
`;

const ExplainerBox = styled.div`
  max-width: 600px;
  margin: ${p => p.theme.spacing[3]}px auto 0;
  padding: ${p => p.theme.spacing[4]}px;
  background: #FCFAF5;
  border: 1px solid rgba(218,165,32,0.2);
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.7;
  color: ${p => p.theme.colors.text.secondary};
  text-align: left;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};

  p { margin: 0 0 ${p => p.theme.spacing[2]}px; }
  p:last-child { margin-bottom: 0; }
`;

const Title = styled.h3`
  font-size: 15px;
  color: #8B4513;
  margin: 0 0 ${p => p.theme.spacing[2]}px;
  font-weight: 600;
`;

const AboutTradition = ({ lang }) => {
  const t = useLocale(lang, 'ramaShalaka');
  const [expanded, setExpanded] = useState(false);

  const toggleLabel = expanded
    ? (t.aboutToggleOpen || 'Close')
    : (t.aboutToggleClosed || 'What is Rama Shalaka Prashnavali?');

  return (
    <div>
      <ToggleLink
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        {toggleLabel}
      </ToggleLink>

      {expanded && (
        <ExplainerBox>
          <Title>{t.aboutToggleClosed || 'What is Rama Shalaka Prashnavali?'}</Title>
          <p>{t.aboutOrigin || "This tool is based on a tradition from Sri Tulsidas's Ramacharitmanas (~1574 CE)."}</p>
          <p>{t.aboutHow || '81 letters are arranged in a 9×9 grid. Each cell is the start of a 9-letter path that spells a verse from the epic.'}</p>
          <p>{t.aboutIntention || 'Hold a question in mind, select a cell, and receive the verse as guidance.'}</p>
          <p>{t.aboutCulture || 'This tradition is practiced in temples and homes across India as a form of spiritual consultation.'}</p>
        </ExplainerBox>
      )}
    </div>
  );
};

export default AboutTradition;
